import React from "react";
import YearBuildField from "./year-build-field";
import LotSizeField from "./lot-sie-field";
import RoofCoverField from "./roof-cover-field";

// ─── Option lists for multi-select (terms) filters ────────────────────────────
// Pool Type values — all 11 are sent together (comma-joined) when the single
// "Has Any Pool / Spa" checkbox is checked, so backend's terms-OR query matches
// any pool/spa type. Broadens results vs requiring the user to guess types.
const POOL_OPTIONS = [
  "Above-Ground Pool",
  "Community Pool or Spa",
  "Enclosed",
  "Heated Pool",
  "Indoor Pool",
  "In-Ground Pool",
  "Pool - Yes",
  "Pool & Spa",
  "Solar Heated",
  "Spa or Hot Tub (only)",
  "Vinyl In-Ground Pool",
];
const POOL_ANY_VALUE = POOL_OPTIONS.join(",");
// ─────────────────────────────────────────────────────────────────────────────

export default function BuildingLotMoreFilters({
  register,
  filterData,
  setValue,
  watch,
}) {
  return (
    <>
      {/* ROW 1 */}
      <div className="col half_flex_form">
        <YearBuildField
          register={register}
          filterData={filterData}
          setValue={setValue}
          watch={watch}
          fieldNamePrefix="building_lot"
        />
      </div>

      <div className="col half_flex_form">
        <LotSizeField
          register={register}
          filterData={filterData}
          fieldNamePrefix="building"
          setValue={setValue}
          watch={watch}
        />
      </div>

      {/* ROW 2 — Zoning (left) + Pool Type single-checkbox (right) */}
      <div className="col half_flex_form nested_half_flex">
        <div className="form_blk">
          <h6>Zoning</h6>
          <div className="half_flex">
            <div className="half_field">
              <input
                type="text"
                name="zonedcodelocal"
                className="input"
                placeholder="Example: C2, I3, R5"
                {...register("zonedcodelocal")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col half_flex_form">
        <div className="form_blk">
          <h6>Pool Type</h6>
          <div className="lbl_btn">
            <input
              type="checkbox"
              id="building_pool_any"
              value={POOL_ANY_VALUE}
              {...register("building_pool")}
              defaultChecked={!!filterData?.building_pool}
            />
            <label htmlFor="building_pool_any" style={{ fontWeight: "normal" }}>
              Has Any Pool / Spa
            </label>
          </div>
        </div>
      </div>

      {/* ROW 3 — Roof Cover (full width, 4-col internal grid) */}
      <div
        className="col half_flex_form"
        style={{ width: "100%", paddingLeft: 0, paddingRight: 0 }}
      >
        <RoofCoverField filterData={filterData} setValue={setValue} columns={4} />
      </div>
    </>
  );
}
